<template>
  <div>
    <h2>ぎゃゑもι″ま＜   ､ζ､°れ〜ゃ〜 （ゝω・）v</h2>
  </div>
</template>

<script>
export default {
  name: 'app-title'
}

</script>

<style scoped>
h2 {
  font-family: "mikiyu", "Nico Moji"
}

div {
  margin-top: 40px;
}

</style>



// WEBPACK FOOTER //
// AppTitle.vue?43d505e3